import UserLedgerList from '@/component/point/point-list/UserLedgerList';

export default function PointLedgerList() {
  return (
    <>
      <UserLedgerList />
    </>
  );
}
